export default __webpack_public_path__ + "static/featured_speaker_animation-e1d43a57e450b90bab4c33c86a172f9c.gif";